import clsx from 'clsx';
import { generateDynamicThemeToken } from '../../../ThemeProvider';
import { getDynamicThemeToken } from '../theme';
import { buttonClasses } from '../style';
import { validIconButtonType, validType } from '../util';
import { getZoomIconDefaultStyles } from '../../../Shared/zoomIcon';
export function getIconButtonStyle(theme, props) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName: 'Button',
        theme,
        dynamicToken,
    });
    const getIconButtonSizeCSS = (btnSize) => {
        const size = btnSize;
        const styles = {
            height: tk(token.iconButton.height[size]),
            minWidth: tk(token.iconButton.width[size]),
            width: tk(token.iconButton.width[size]),
            borderRadius: tk(token.iconButton.borderRadius[size]),
            padding: 0,
            fontSize: tk(token.iconButton.fontSize[size]),
            svg: {
                fontSize: tk(token.iconButton.iconSize[size]),
            },
            // icon
            [`.${buttonClasses.startIcon}, .${buttonClasses.endIcon}`]: {
                display: 'none',
            },
        };
        if (props?.fullWidth) {
            delete styles.width;
        }
        return styles;
    };
    const getIconButtonTypeCSS = (btnType) => {
        const type = btnType && validIconButtonType(btnType) ? btnType : 'default';
        return {
            background: tk(token.iconButton.background[type].default),
            color: tk(token.iconButton.color[type].default),
            borderColor: tk(token.iconButton.borderColor[type].default),
            '&:hover': {
                background: tk(token.iconButton.background[type].hover),
                color: tk(token.iconButton.color[type].hover),
                borderColor: tk(token.iconButton.borderColor[type].hover),
            },
            '&:active': {
                background: tk(token.iconButton.background[type].active),
                color: tk(token.iconButton.color[type].active),
                borderColor: tk(token.iconButton.borderColor[type].active),
            },
        };
    };
    const getDisabledCSS = (btnType) => {
        const type = btnType && validType(btnType) ? btnType : 'default';
        const disabledCSS = {
            background: tk(token.background.disabled[type].default),
            color: tk(token.color.disabled[type].default),
            borderColor: tk(token.borderColor.disabled[type].default),
            // fontWeight: tk(token.fontWeight[type]),
            '&:hover': {
                background: tk(token.background.disabled[type].hover),
                color: tk(token.color.disabled[type].hover),
                borderColor: tk(token.borderColor.disabled[type].hover),
            },
            '&:active': {
                background: tk(token.background.disabled[type].active),
                color: tk(token.color.disabled[type].active),
                borderColor: tk(token.borderColor.disabled[type].active),
            },
        };
        return disabledCSS;
    };
    const getIconButtonDangerCSS = (btnType) => {
        const type = btnType && validType(btnType) ? btnType : 'default';
        const dangerCSS = {
            background: tk(token.background.danger[type].default),
            color: tk(token.color.danger[type].default),
            borderColor: tk(token.borderColor.danger[type].default),
            // fontWeight: tk(token.fontWeight[type]),
            '&:hover': {
                background: tk(token.background.danger[type].hover),
                color: tk(token.color.danger[type].hover),
                borderColor: tk(token.borderColor.danger[type].hover),
            },
            '&:active': {
                background: tk(token.background.danger[type].active),
                color: tk(token.color.danger[type].active),
                borderColor: tk(token.borderColor.danger[type].active),
            },
        };
        return dangerCSS;
    };
    const getIconButtonDisabledCSS = (btnType) => {
        const type = btnType && validIconButtonType(btnType) ? btnType : 'default';
        const disabledCSS = {
            background: tk(token.iconButton.background.disabled[type].default),
            color: tk(token.iconButton.color.disabled[type].default),
            borderColor: tk(token.iconButton.borderColor.disabled[type].default),
            // fontWeight: tk(token.fontWeight[type]),
            '&:hover': {
                background: tk(token.iconButton.background.disabled[type].hover),
                color: tk(token.iconButton.color.disabled[type].hover),
                borderColor: tk(token.iconButton.borderColor.disabled[type].hover),
            },
            '&:active': {
                background: tk(token.iconButton.background.disabled[type].active),
                color: tk(token.iconButton.color.disabled[type].active),
                borderColor: tk(token.iconButton.borderColor.disabled[type].active),
            },
        };
        return disabledCSS;
    };
    const getIconButtonLoadingCSS = (btnType) => {
        const type = btnType && validIconButtonType(btnType) ? btnType : 'default';
        const loadingCSS = {
            color: tk(token.iconButton.color.loading[type].default),
            '&:hover': {
                color: tk(token.iconButton.color.loading[type].hover),
            },
            '&:active': {
                color: tk(token.iconButton.color.loading[type].active),
            },
            '&, &:hover, &:active': {
                background: tk(token.iconButton.background[type].default),
                borderColor: tk(token.iconButton.borderColor[type].default),
            },
            [`&.${buttonClasses.danger}`]: {
                '&, &:hover, &:active': {
                    background: tk(token.background.danger[type === 'overlay' ? 'default' : type]
                        .default),
                    borderColor: tk(token.borderColor.danger[type === 'overlay' ? 'default' : type]
                        .default),
                },
            },
        };
        return loadingCSS;
    };
    const newRootStyle = {
        [`&.${buttonClasses.root}`]: {
            textTransform: 'none',
            // boxShadow: 'none',
            borderStyle: 'solid',
            borderWidth: 1,
            whiteSpace: 'nowrap',
            // box style
            height: tk(token.height.default),
            minWidth: tk(token.minWidth.default),
            padding: tk(token.padding.default),
            borderRadius: tk(token.borderRadius.default),
            // text style
            fontSize: tk(token.fontSize.default),
            fontWeight: tk(token.fontWeight.default),
            // color style
            background: tk(token.background.default.default),
            color: tk(token.color.default.default),
            borderColor: tk(token.borderColor.default.default),
            '&:hover': {
                background: tk(token.background.default.hover),
                color: tk(token.color.default.hover),
                borderColor: tk(token.borderColor.default.hover),
            },
            '&:active': {
                background: tk(token.background.default.active),
                color: tk(token.color.default.active),
                borderColor: tk(token.borderColor.default.active),
            },
            [`&.${buttonClasses.focusVisible}, &:focus-visible`]: {
                outline: `2px solid ${tk(token.focusBorderColor)}`,
                outlineOffset: '2px',
            },
            // icon
            [`.${buttonClasses.startIcon}, .${buttonClasses.endIcon}`]: {
                fontSize: tk(token.fontSize.default),
                svg: {
                    fontSize: tk(token.fontSize.default),
                },
            },
            [`&.${buttonClasses.disabled}`]: {
                cursor: 'not-allowed',
                ...getDisabledCSS(),
                [`&.${buttonClasses.primary}`]: getDisabledCSS('primary'),
                [`&.${buttonClasses.secondary}`]: getDisabledCSS('secondary'),
                [`&.${buttonClasses.tertiary}`]: getDisabledCSS('tertiary'),
            },
            // iconButton variant style
            [`&.${buttonClasses.iconButton}`]: {
                ...getIconButtonSizeCSS('medium'),
                ...getIconButtonTypeCSS('default'),
                [`&.${buttonClasses.extraSmall}`]: getIconButtonSizeCSS('extraSmall'),
                [`&.${buttonClasses.small}`]: getIconButtonSizeCSS('small'),
                [`&.${buttonClasses.medium}`]: getIconButtonSizeCSS('medium'),
                [`&.${buttonClasses.large}`]: getIconButtonSizeCSS('large'),
                [`&.${buttonClasses.extraLarge}`]: getIconButtonSizeCSS('extraLarge'),
                [`&.${buttonClasses.primary}`]: getIconButtonTypeCSS('primary'),
                [`&.${buttonClasses.secondary}`]: getIconButtonTypeCSS('secondary'),
                [`&.${buttonClasses.tertiary}`]: getIconButtonTypeCSS('tertiary'),
                [`&.${buttonClasses.overlay}`]: getIconButtonTypeCSS('overlay'),
                [`&.${buttonClasses.danger}`]: {
                    ...getIconButtonDangerCSS(),
                    [`&.${buttonClasses.primary}`]: getIconButtonDangerCSS('primary'),
                    [`&.${buttonClasses.secondary}`]: getIconButtonDangerCSS('secondary'),
                    [`&.${buttonClasses.tertiary}`]: getIconButtonDangerCSS('tertiary'),
                },
                [`&.${buttonClasses.loading}`]: {
                    cursor: 'default',
                    ...getIconButtonLoadingCSS(),
                    [`&.${buttonClasses.primary}`]: getIconButtonLoadingCSS('primary'),
                    [`&.${buttonClasses.secondary}`]: getIconButtonLoadingCSS('secondary'),
                    [`&.${buttonClasses.tertiary}`]: getIconButtonLoadingCSS('tertiary'),
                    [`&.${buttonClasses.overlay}`]: getIconButtonLoadingCSS('overlay'),
                },
                [`&.${buttonClasses.disabled}, &.${buttonClasses.loading}.${buttonClasses.disabled}`]: {
                    cursor: 'not-allowed',
                    ...getIconButtonDisabledCSS(),
                    [`&.${buttonClasses.primary}`]: getIconButtonDisabledCSS('primary'),
                    [`&.${buttonClasses.secondary}`]: getIconButtonDisabledCSS('secondary'),
                    [`&.${buttonClasses.tertiary}`]: getIconButtonDisabledCSS('tertiary'),
                    [`&.${buttonClasses.overlay}`]: getIconButtonDisabledCSS('overlay'),
                },
            },
            ...getZoomIconDefaultStyles(),
        },
    };
    return newRootStyle;
}
export function generateIconButtonClassnames() {
    const nameList = [];
    nameList.push(buttonClasses.root);
    nameList.push(buttonClasses.iconButton);
    return clsx(nameList);
}
